<!--
 * @Description  : 个人/企业信用
 * @Author       : 钱磊
 * @Date         : 2024-07-18 10:10:40
 * @LastEditors  : 王帅
 * @LastEditTime : 2025-10-15 11:28:23
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\assessment-system\PersonalCredit.vue
-->
<template>
	<div class="operation-layout h100 evaluate-score-main" :class="{ pd0: !routeQuery }">
		<!-- 列表查询页 -->
		<filter-layout @search="doSearch('1')" @reset="doRefresh" v-if="!routeQuery">
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchObj" label-width="120px">
					<el-form-item label="信用对象名称：" prop="assName">
						<el-input :placeholder="'请输入个人姓名/企业名称'" clearable v-model="searchObj.assName"></el-input>
					</el-form-item>
					<el-form-item label="信用对象类型：" prop="assType">
						<el-select v-model="searchObj.assType" placeholder="请选择" clearable>
							<el-option label="个人" value="0"></el-option>
							<el-option label="企业" value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="证件号：" prop="assNo">
						<el-input :placeholder="'请输入身份证号/统一社会信用代码'" clearable v-model="searchObj.assNo"></el-input>
					</el-form-item>
				</el-form>
			</template>
			<template #content>
				<!-- 非请求参数 正常查看 -->
				<div class="operation-main">
					<div class="operation-header">
						<div class="title">
							信用汇总对象:<span class="red">{{ searchObj.totalResult }}条</span>
						</div>
						<div class="btnGroups"></div>
					</div>
					<div class="operation-container w-table-layout w-table-page">
						<div class="w-table-content" v-show="tableShow">
							<vxe-table
								:data="tableObj.tableData"
								:loading="tableObj.loading"
								:border="tableObj.border"
								:resizable="tableObj.resizable"
								:size="tableObj.size"
								:height="tableObj.height"
								highlight-current-row
								highlight-hover-row
								show-overflow="tooltip"
								show-header-overflow="tooltip"
							>
								<vxe-table-column type="seq" title="序号" width="60" align="center"></vxe-table-column>
								<vxe-table-column field="assName" title="信用对象名称" min-width="160" align="center"> </vxe-table-column>
								<vxe-table-column field="assType" title="信用对象类型" width="160" align="center"
									><template v-slot="{ row }">
										{{ row.assType ? '企业' : '个人' }}
									</template>
								</vxe-table-column>
								<vxe-table-column field="assNo" title="证件号" min-width="160" show-overflow align="center"></vxe-table-column>
								<vxe-table-column field="generalScore" title="综合评分" width="200" show-overflow align="center">
									<template v-slot="{ row }">
										{{ row.generalScore + '分' }}
									</template></vxe-table-column
								>
								<vxe-table-column field="assRate" title="好评率" width="200" align="center">
									<template v-slot="{ row }">
										{{ row.assRate + '%' }}
									</template>
								</vxe-table-column>
								<vxe-table-column title="操作" width="120" align="center">
									<template v-slot="{ row }">
										<el-button type="primary" size="small" round plain class="table-btn" @click="getRecords(row)">
											评级记录
										</el-button>
									</template>
								</vxe-table-column>
							</vxe-table>
						</div>
						<div class="w-table-footer">
							<vxe-pager
								size="mini"
								:current-page="searchObj.currentPage"
								:page-size="searchObj.pageSize"
								:total="searchObj.totalResult"
								class="text-center"
								:page-sizes="[10, 20, 50, 100]"
								:layouts="['Total', 'Sizes', 'PrevPage', 'JumpNumber', 'NextPage', 'FullJump']"
								@page-change="handlePageChange"
							>
							</vxe-pager>
						</div>
					</div>
				</div>
			</template>
		</filter-layout>

		<!-- 详情页 -->
		<template v-else>
			<RatingRecords @close="doSearch"></RatingRecords>
		</template>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import RatingRecords from './components/RatingRecords'
import { getSummaryPageList } from 'api/modules/assessment-system/PersonalCredit'
export default {
	components: {
		RatingRecords
	},
	data() {
		return {
			showFilter: true,
			searchObj: {
				assName: '',
				assType: '',
				assNo: '',
				currentPage: 1,
				pageSize: 10,
				totalResult: 0
			},
			// 表格对象
			tableObj: {
				tableData: [],
				loading: false,
				border: true,
				resizable: true,
				size: 'small',
				height: '100%'
			},
			tableShow: true
		}
	},
	created() {
		// 如果是 返回的
		if (this.isBack) {
			if (this.$getSessionItem('searchObj')) {
				this.searchObj = JSON.parse(this.$getSessionItem('searchObj'))

				// 移除 避免污染
				this.$removeSessionItem('searchObj')
			}

			if (this.$getSessionItem('currentPage')) {
				this.currentPage = JSON.parse(this.$getSessionItem('currentPage'))

				// 移除 避免污染
				this.$removeSessionItem('currentPage')
			}

			if (this.$getSessionItem('pageSize')) {
				this.pageSize = JSON.parse(this.$getSessionItem('pageSize'))

				// 移除 避免污染
				this.$removeSessionItem('pageSize')
			}
			if (this.$getSessionItem('recordsData')) {
				// 移除 避免污染
				this.$removeSessionItem('recordsData')
			}
		}
		this.doSearch()
	},
	methods: {
		// 获取个人、企业信用分页列表
		doSearch(page) {
			if (page) {
				this.searchObj.pageSize = 10
				this.searchObj.currentPage = 1
			}
			let params = {
				size: this.searchObj.pageSize, // 当前每页条数
				current: this.searchObj.currentPage, // 当前页码
				assName: this.searchObj.assName, // 信用对象名称
				assNo: this.searchObj.assNo, // 证件号
				assType: this.searchObj.assType // 信用对象类型 0：个人 1：企业
			}
			this.tableObj.loading = true
			getSummaryPageList(params).then((res) => {
				this.tableObj.loading = false
				if (res.operationCode === 1) {
					this.tableObj.tableData = res.data.records
					this.searchObj.totalResult = parseInt(res.data.total)
				}
			})
		},
		//刷新/重置
		doRefresh() {
			this.searchObj.pageSize = 10
			this.searchObj.currentPage = 1
			this.searchObj.assProject = ''
			this.searchObj.assName = ''
			this.searchObj.assType = ''
			this.searchObj.assNo = ''
			this.doSearch()
		},
		//获取评级记录
		getRecords(row) {
			// 存值
			this.$setSessionItem('searchObj', JSON.stringify(this.searchObj))
			this.$setSessionItem('currentPage', JSON.stringify(this.searchObj.currentPage))
			this.$setSessionItem('pageSize', JSON.stringify(this.searchObj.pageSize))
			// 数据
			this.$setSessionItem('recordsData', JSON.stringify(row))

			this.$router.push({
				path: '/personal-credit',
				query: {
					type: 'rating',
					id: row.assId,
					assType: row.assType
				}
			})
		},

		// 切换状态
		changeState() {
			this.showFilter = !this.showFilter
		},
		// 切换分页
		handlePageChange({ currentPage, pageSize }) {
			this.searchObj.currentPage = currentPage
			this.searchObj.pageSize = pageSize
			this.doSearch()
		}
	},
	computed: {
		routeQuery() {
			return this.$route.query.type
		},
		...mapState('app', { isBack: (state) => state.isBack }),
		...mapState('dict', {
			yyyw: (state) => state.yyyw
		})
	},
	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		showFilter() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
		}
	}
}
</script>

<style></style>
